module.exports = __webpack_public_path__ + "static/media/checkbox-unchecked-icon.73605d7f.svg";